import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { DependentsService } from "src/app/services/dependents.service";
import { DependentGridList } from "src/app/models/dependent-grid";

import { DialogDependentComponent } from "src/app/components/shared/dialog/dependent.component";
import { DependentDialogModel } from "src/app/models/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { TableColumn } from "src/app/models/table";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { SvgMatType } from "src/app/constants/icons";

@Component({
    selector: 'mwp-profile-dependents',
    templateUrl: './dependents.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileDependentsComponent implements OnInit {

    public apiUrl = ContentHeaderKey.ProfileDependents;

    public dependentMatTableData: MatTableDataSource<DependentGridList>;
    public dependentColumns: TableColumn[] = new Array<TableColumn>;

    constructor(
        private dependentsService: DependentsService,
        public dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        this.dependentsService.getDependents().subscribe((response: DependentGridList[]) => {
            let l_RunOnce: boolean;
            let l_HasMessage: boolean;
            response.forEach((r: DependentGridList) => {
                if (!l_RunOnce && r.isEditable) {
                    l_RunOnce = r.isEditable;
                    this.dependentColumns.push({
                        columnName: 'Edit',
                        propertyId: 'dependentID',
                        columnType: TableColumnType.button,
                        dataTypeText: 'Edit',
                        hideElementByPropertyId: 'isEditable',
                        width: "15%"
                    });
                }
                if (!l_HasMessage && r.disabledMessage && r.disabledMessage != '')
                    l_HasMessage = true;
            });

            if (l_HasMessage)
                this.dependentColumns.push({
                    columnName: 'Name',
                    propertyId: 'dependentName',
                    columnType: TableColumnType.labelAndToolTip,
                    svgCustomName: SvgMatType.SmsFailed,
                    toolTip: 'disabledMessage',
                    toolTipCSS: 'error',
                    toolTipDisplayEnd: true,
                });
            else
                this.dependentColumns.push({
                    columnName: 'Name',
                    propertyId: 'dependentName',
                    columnType: TableColumnType.label,
                });

            this.dependentColumns.push({
                    columnName: 'Relationship',
                    propertyId: 'dependentRelationship',
                    columnType: TableColumnType.label,
                },
                {
                    columnName: 'SSN',
                    propertyId: 'dependentSsn',
                    columnType: TableColumnType.label,
                    width: "12%"
                },
                {
                    columnName: 'Date of Birth',
                    propertyId: 'dependentDateOfBirth',
                    columnType: TableColumnType.label,
                    width: "12%"
                },
                {
                    columnName: 'Age',
                    propertyId: 'dependentAge',
                    columnType: TableColumnType.label,
                    width: "5%"
                },
                {
                    columnName: 'Gender',
                    propertyId: 'dependentGender',
                    columnType: TableColumnType.label,
                    width: "10%"
                },
                {
                    columnName: 'Phone Number',
                    propertyId: 'callNumber',
                    columnType: TableColumnType.label,
                }
            );

            this.dependentMatTableData = new MatTableDataSource<DependentGridList>;
            this.dependentMatTableData.data = response;
        });
    }

    public openDialog(dependent: DependentGridList): void {
        const l_DependentDialogModel = new DependentDialogModel();
        l_DependentDialogModel.selectedDependentId = dependent.dependentID;
        const dialogRef = this.dialog.open(DialogDependentComponent, { data: l_DependentDialogModel, panelClass: 'mwp-modal-override-1300' });

        dialogRef.afterClosed().subscribe((response: DependentGridList[]) => {
            if (response) {
                this.dependentMatTableData = new MatTableDataSource<DependentGridList>;
                this.dependentMatTableData.data = response;
            }
        });
    }
}

